import ForgotPasswordForm from "../../components/auth/ForgotPasswordForm";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const ForgotPassword = () => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader style={{ marginBottom: "10px" }}>
        <CardTitle className="text-2xl font-bold text-center my-5">
          Forgot Password
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ForgotPasswordForm />
      </CardContent>
    </Card>
  );
};

export default ForgotPassword;
